import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton } from "@mui/material";
import { FC } from "react";
import styles from './ConfirmModal.module.scss';
import CloseIcon from '@mui/icons-material/Close';

interface IConfirmModalProps {
  open: boolean;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  danger?: boolean;
  onCancel: () => void;
  closeOnBackdropClick?: boolean;
  isLoading?: boolean;
}

export const ConfirmModal: FC<IConfirmModalProps> = (
  {
    open,
    title,
    description,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
    danger,
    closeOnBackdropClick,
    isLoading
  }
) => {
  const handleClose = () => {
    if (closeOnBackdropClick) {
      onCancel();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={styles.dialogWindow}
      PaperProps={{
        sx: { borderRadius: '16px' }
      }}
      onClick={(e) => e.stopPropagation()} >
      <DialogTitle style={{ paddingTop: '24px', color: '#3E444A', fontSize: '19px', fontWeight: '600', display: "flex", justifyContent: "space-between", alignItems: "center", width: '80%' }}>
        {title}
        <IconButton
          aria-label="close"
          onClick={onCancel}
          className={styles.closeButton}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ width: '560px' }}
        onClick={(e) => e.stopPropagation()} >
        <DialogContentText style={{ color: "#68717B", paddingTop: '9px', fontWeight: '500', fontSize: '16px' }}>
          {description}
        </DialogContentText>
      </DialogContent>
      <Divider sx={{ paddingTop: '18px', width: '90%', margin: '0 auto' }} />
      <DialogActions style={{ color: "black", width: '512px', margin: "0 auto", padding: "16px 0 32px 0" }}
        onClick={(e) => e.stopPropagation()} >
        <Button
          className={styles.cancelButton}
          style={{
            textTransform: "capitalize",
            marginRight: "5px",
            fontWeight: 500,
            fontFamily: "Raleway",
            lineHeight: "24px",
            borderRadius: "12px",
            padding: "8px 16px",
            color: "#0090D1",
            fontSize: "15px"
          }}
          onClick={onCancel}
          sx={{ width: 'auto', minWidth: 'unset' }}
        >
          {cancelText}
        </Button>
        <Button
          autoFocus
          style={{
            fontFamily: "Raleway",
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "24px",
            color: "#fff",
            background: danger ? "#d14100" : "#0090D1",
            padding: "8px 16px",
            borderRadius: "12px",
            textTransform: "none",
          }}
          className={styles.confirmButton}
          onClick={onConfirm}
          variant='contained'
          sx={{ color: '#FFFFFF' }}
          disabled={isLoading}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

